import { render } from "./ModalTitle.vue?vue&type=template&id=c8415d98&ts=true"
import script from "./ModalTitle.vue?vue&type=script&lang=ts"
export * from "./ModalTitle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__